import React, { FC } from 'react';

import {
	MobileErrorMessage,
	MobileErrorType
} from 'src/apps/mobile-common/components/mobile-error-message/MobileErrorMessage';
import { ProductType } from 'src/common/interfaces/Tenant';

interface MobileSdkErrorProps {
	errorType?: MobileErrorType;
}

export const MobileSdkError: FC<MobileSdkErrorProps> = ({
	errorType = MobileErrorType.LOADING_ERROR
}) => {
	return <MobileErrorMessage errorType={errorType} productType={ProductType.MOBILE_SDK} />;
};
